<template>
  <div class="hot" v-if="loading && haveActicy === 1">
    <div class="hot-box">
      <div class="labels">
        <label :class="classId === 0 ? 'select' : ''" @click="classId = 0">全部</label>
        <label :class="classId === item.ClassId ? 'select' : ''" v-for="item in classList" :key="item.ClassId" @click="classId = item.ClassId">
          {{item.ClassCName}}
        </label>
      </div>
      <div class="class">
        <div :class="insideTime(item.StartDate, item.CloseDate).type === 1 ? 'box not-started' : insideTime(item.StartDate, item.CloseDate).type === 2 ? 'box end' : 'box'"
          v-for="(item, key) in courseList" :key="key">
          <div class="end-box" v-if="insideTime(item.StartDate, item.CloseDate).type === 2">
            <div class="flag">抢购结束</div>
          </div>
          <div class="has-off" v-if="item.ZheKou">
            <img src="https://img2.233.com/wx/union/618/2021/pc/five-off.png">
            <span>{{item.ZheKou}}折</span>
          </div>
          <div class="img">
            <img :src="`https://img.233.com/wx/img/union/courseimg/20200225/${item.ExamdaClassEname}/${item.BzNum}.jpg`" onerror="this.src='https://img.233.com/wx/img/union/courseimg/20200225/default.jpg'">
          </div>
          <h3>{{item.CourseName}}</h3>
          <div class="hot-price">
            <span>抢购价</span>
            <label>￥</label>
            <b v-if="item.MinActivityPrice === item.MaxActivityPrice">{{item.MaxActivityPrice}}</b>
            <b v-else>{{item.MinActivityPrice}}-{{item.MaxActivityPrice}}</b>
          </div>
          <div class="old-price">
            <span>原价</span>
            <del v-if="item.MinGoodPrice === item.MaxGoodPrice">￥{{item.MaxGoodPrice}}</del>
            <del v-else>￥{{item.MinGoodPrice}}-{{item.MaxGoodPrice}}</del>
          </div>
          <div class="count-down" v-if="insideTime(item.StartDate, item.CloseDate).type === 1">
            {{insideTime(item.StartDate, item.CloseDate).text}}
          </div>
          <div class="count-down" v-else-if="insideTime(item.StartDate, item.CloseDate).type === 2">
            {{insideTime(item.StartDate, item.CloseDate).text}}
          </div>
          <div class="count-down" v-else>
            <span>距结束</span>
            <label>{{insideTime(item.StartDate, item.CloseDate).day}}</label>
            <span>天</span>
            <label>{{insideTime(item.StartDate, item.CloseDate).hour}}</label>
            <span>时</span>
            <label>{{insideTime(item.StartDate, item.CloseDate).minute}}</label>
            <span>分</span>
          </div>
          <div class="button-box">
            <div class="button" v-if="insideTime(item.StartDate, item.CloseDate).type === 1">
              <span>即将开始</span>
            </div>
            <div class="button" v-else-if="insideTime(item.StartDate, item.CloseDate).type === 2">
              <span>抢购结束</span>
            </div>
            <div class="button" @click="openCourseDialog(item)" v-else>
              <span>立即抢购</span>
              <img src="https://img2.233.com/wx/union/618/2021/pc/right-arrow.png">
            </div>
          </div>
        </div>
        <template v-if="Count > 1">
          <div class="left-arrow off" v-if="pIndex === 1"/>
          <div class="left-arrow" @click="GetPinTuanBaoKuanCourse(pIndex - 1)" v-else/>
          <div class="right-arrow off" v-if="pIndex === Count"/>
          <div class="right-arrow" @click="GetPinTuanBaoKuanCourse(pIndex + 1)" v-else/>
        </template>
      </div>
      <div class="pages" v-if="Count > 1">
        <label v-for="ii in Count" :key="ii" :class="ii === pIndex ? 'select' : ''" @click="GetPinTuanBaoKuanCourse(ii)">{{ii}}</label>
      </div>
    </div>
  </div>
</template>

<script>
import { GetPinTuanBaoKuanCourse } from "../../../lib/request"
export default {
  name: "Welfare",
  props: {
    curTime: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      haveActicy: 0,
      classList: [],
      courseList: [],
      classId: 0,
      pIndex: 1,
      Count: 0
    }
  },
  watch: {
    classId() {
      this.GetPinTuanBaoKuanCourse()
    }
  },
  mounted() {
    this.GetPinTuanBaoKuanCourse()
  },
  methods: {
    insideTime(startTime, endTime) {
      if (this.curTime < new Date(startTime).getTime()) {
        return {
          type: 1,
          text: (new Date(startTime).getMonth()  + 1) + "月" + new Date(startTime).getDate() + "日 " + new Date(startTime).getHours() +"点开售"
        }
      } else if (this.curTime > new Date(endTime).getTime()) {
        return {
          type: 2,
          text: "已结束"
        }
      } else {
        return {
          type: 3,
          text: "",
          ...this.formatAcitivityDate(new Date(endTime) - new Date())
        }
      }
    },
    formatAcitivityDate(time) {
      const add0 = v => v > 9 ? v : "0" + v
      const day = add0(Math.floor(time / 1000 / 60 / 60 / 24))
      const hour = add0(Math.floor(time / 1000 / 60 / 60) - day * 24)
      const minute = add0(Math.floor(time / 1000 / 60) - day * 24 * 60 - hour * 60)
      const second = add0(Math.floor(time / 1000) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60)
      return { day, hour , minute, second }
    },
    GetPinTuanBaoKuanCourse(pIndex = 1) {
      GetPinTuanBaoKuanCourse({ type: 2, classId: this.classId, pIndex, pSize: 3 }, (res) => {
        this.loading = true
        const { Result, ResultDescription, Count = 0, Index = 0 } = res
        if (!ResultDescription) {
          const { haveActicy = 0, classList = [], courseList = [] } = Result
          this.haveActicy = haveActicy
          this.classList = classList
          this.courseList = courseList
          this.Count = Count
          this.pIndex = Index
          haveActicy === 1 && this.$emit("updateVisibilit", "hot")
        }
      })
    },
    openCourseDialog(item) {
      this.$emit("openCourseDialog", item)
    }
  }
}
</script>

<style lang="scss" scoped>
.hot{
  background: url('https://img2.233.com/wx/union/618/2021/pc/hot-bg.png') no-repeat top center;
  padding-bottom: 54px;
  .hot-box{
    margin: 0 auto;
    width: 1100px;
    padding: 0 44px;
    box-sizing: border-box;
    .labels{
      padding: 127px 0 38px;
      text-align: center;
      label{
        display: inline-block;
        height: 36px;
        background: #FCEBE9;
        border-radius: 18px;
        line-height: 36px;
        width: 120px;
        text-align: center;
        color: #E23B29;
        font-size: 18px;
        font-weight: 800;
        margin: 0 12px;
        cursor: pointer;
      }
      .select{
        background: linear-gradient(0deg, #D44441 0%, #CB3433 97%);
        border: 2px solid #FFE871;
        // border-image: linear-gradient(0deg, #FFE871, #FFEC92, #FFCA6D) 2 2;
        border-radius: 18px;
        color: #fff;
      }
    }
    .class{
      position: relative;
      .box{
        width: 324px;
        height: 400px;
        border-radius: 8px;
        background: #fff;
        padding: 16px 0;
        box-sizing: border-box;
        display: inline-block;
        margin: 0 20px 20px 0;
        position: relative;
        vertical-align: top;
        &:nth-child(3n){
          margin-right: 0;
        }
        .has-off{
          position: absolute;
          right: 0;
          top: -1px;
          span{
            position: absolute;
            top: 0;
            left: 0;
            width: 61px;
            height: 53px;
            line-height: 46px;
            font-size: 20px;
            color: #fff;
            text-align: center;
          }
        }
        .img{
          padding: 0 16px;
          box-sizing: border-box;
          height: 165px;
          img{
            width: 292px;
            border-radius: 8px;
            vertical-align: top;
          }
        }
        h3{
          padding: 0 16px;
          box-sizing: border-box;
          color: #333;
          font-size: 22px;
          line-height: 22px;
          font-weight: 400;
          margin: 10px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .hot-price{
          padding: 0 16px;
          box-sizing: border-box;
          height: 32px;
          span{
            color: #E53F50;
            font-weight: 800;
            font-size: 16px;
            line-height: 32px;
          }
          label{
            color: #E53F50;
            font-weight: 800;
            font-size: 22px;
            line-height: 32px;
          }
          b{
            color: #E53F50;
            font-size: 32px;
            line-height: 32px;
            height: 32px;
            display: inline-block;
          }
        }
        .old-price{
          padding: 0 16px;
          box-sizing: border-box;
          margin: 10px 0;
          span, del{
            color: #999;
            font-size: 13px;
            font-weight: 400;
            line-height: 17px;
          }
        }
        .count-down{
          height: 32px;
          line-height: 32px;
          text-align: center;
          background: linear-gradient(90deg, #FFEDDD, #F3B8A1);
          span{
            font-size: 14px;
            color: #6E4D38;
            font-weight: 400;
          }
          label{
            color: #fff;
            background: #E11D2B;
            border-radius: 3px;
            font-weight: 800;
            font-size: 14px;
            padding: 0 2px;
            height: 21px;
            line-height: 21px;
            display: inline-block;
            margin: 0 4px;
          }
        }
        .button-box{
          width: 100%;
          padding: 0 16px;
          box-sizing: border-box;
          margin-top: 10px;
          .button{
            background: linear-gradient(73deg, #F21A3E 0%, #F5554F 100%);
            border-radius: 24px;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            span{
              font-size: 22px;
              color: #fff;
              font-weight: 800;
              line-height: 22px;
              margin-right: 12px;
            }
          }
        }
      }
      .not-started, .end{
        .count-down{
          background: #F3F3F3;
          color: #666;
        }
        .button-box{
          .button{
            background: #EFEFEF;
            span{
              color: #888;
            }
          }
        }
      }
      .end{
        .end-box{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, .7);
          text-align: center;
          border-radius: 8px;
          .flag{
            height: 50px;
            line-height: 50px;
            color: #fff;
            font-size: 24px;
            font-weight: 800;
            border: 2px solid #FFFFFF;
            border-radius: 8px;
            padding: 0 20px;
            display: inline-block;
            margin-top: 175px;
          }
        }
      }
      .left-arrow{
        position: absolute;
        top: calc(50% - 49.5px);
        left: -44px;
        background: url('https://img2.233.com/wx/union/618/2021/pc/pages-arrow-on.png') no-repeat top center;
        width: 31px;
        height: 89px;
        cursor: pointer;
      }
      .left-arrow.off{
        background: url('https://img2.233.com/wx/union/618/2021/pc/pages-arrow-off.png') no-repeat top center;
        cursor: not-allowed;
        transform: rotate(180deg);
      }
      .right-arrow{
        position: absolute;
        top: calc(50% - 49.5px);
        right: -44px;
        background: url('https://img2.233.com/wx/union/618/2021/pc/pages-arrow-on.png') no-repeat top center;
        width: 31px;
        height: 89px;
        cursor: pointer;
        transform: rotate(180deg);
      }
      .right-arrow.off{
        background: url('https://img2.233.com/wx/union/618/2021/pc/pages-arrow-off.png') no-repeat top center;
        cursor: not-allowed;
        transform: rotate(0);
      }
    }
    .pages{
      text-align: center;
      label{
        display: inline-block;
        width: 28px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        margin: 0 5px;
        background: #8C0112;
        border-radius: 50%;
        color: #FFE4DE;
        font-size: 18px;
        font-weight: 800;
        cursor: pointer;
      }
      .select{
        background: linear-gradient(-29deg, #FFDCC4, #FFB788);
        color: #BB2D3E;
      }
    }
  }
}
</style>